// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import PipDaysToExpiryWidget from '../../shared/components/pip-days-to-expiry-widget';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipsDetails from './pip-details';
import ProductImage from './../../../shared/components/product-image';

const PipsResultsListItem = props =>
    <li className='open-pips-result'>
        <div className='product-image-container'>
            <ProductImage
                baseCode={props.pipProduct.baseMachineCode}
                placeHolderText={props.pipProduct.baseMachineCode}
            />
        </div>
        <div className='pip-product-information-container'>
            <header>
                <Link to={`/products/${props.pipProduct.pin}`}>{props.pipProduct.pin}</Link>
                <span className='pip-completion-status'>{props.pipProduct.pipCompletionStatus.value}</span>
                <PipDaysToExpiryWidget
                    daysLeft={props.pipProduct.daysRemaining}
                    metric={props.pipProduct.metric.key}
                    pipCompletionStatus={props.pipProduct.pipCompletionStatus.key}
                    showIndicatorOnly={false}
                />
            </header>
            <PipsDetails
                pipProduct={props.pipProduct}
            />
        </div>
    </li>;

PipsResultsListItem.displayName = 'PipsResultsListItem';
PipsResultsListItem.propTypes = {
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired
};

export default PipsResultsListItem;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pips-results-list-item.js